import { Grid, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { PageBody } from '../../routes/PageBody'
import { WorkLocationsComponent, WorkLocationsInstructions } from '../onboarding/steps/workLocations'
import { useOrg } from '../organization/useOrg'

export const WorkLocationsPage = () => {
  const org = useOrg()
  if (!org) return null
  return (
    <PageBody maxWidth="lg">
      <Typography variant="h1" gutterBottom>
        Locations &amp; pay groups
      </Typography>

      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <WorkLocationsInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <WorkLocationsComponent />
        </Grid>
      </Grid>
    </PageBody>
  )
}
